import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider } from "@/context/AuthContext";
import AuthGuard from "@/components/AuthGuard";
import AdminBanner from "@/components/AdminBanner";
import Index from "./pages/Index";
import VeckansLunch from "./pages/VeckansLunch";
import Lunchkort from "./pages/Lunchkort";
import LunchkortVisa from "./pages/LunchkortVisa";
import ForetagskortVisa from "./pages/ForetagskortVisa";
import Foretag from "./pages/Foretag";
import Login from "./pages/Login";
import PersonalMenuCMS from "./pages/personal/MenuCMS";
import PersonalKassa from "./pages/personal/Kassa";
import TestLunchkort from "./pages/personal/TestLunchkort";
import CompanyRequests from "./pages/personal/CompanyRequests";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <AppProvider>
        <AuthProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AdminBanner />
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/veckans-lunch" element={<VeckansLunch />} />
                <Route path="/login" element={<Login />} />
                {/* <Route path="/lunchkort" element={<Lunchkort />} />
                <Route path="/lunchkort/visa" element={<LunchkortVisa />} />
                <Route path="/foretagskort/visa" element={<ForetagskortVisa />} />*/}
                <Route path="/foretag" element={<Foretag />} /> 
                
                {/* Protected Staff pages */}
                <Route element={<AuthGuard />}>
                  <Route path="/personal/meny" element={<PersonalMenuCMS />} />
                  <Route path="/personal/kassa" element={<PersonalKassa />} />
                  <Route path="/personal/test-lunchkort" element={<TestLunchkort />} />
                  <Route path="/personal/forfragningar" element={<CompanyRequests />} />
                </Route>

                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </AuthProvider>
      </AppProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
